/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name routes
 * @description
 *
 * # routes
 *
 * The `routes` module provides routing/controllers map.
 */
angular.module('routes', [])
  .config(['$locationProvider', function($location) {
    $location.hashPrefix('!');
  }])
  .config(['$routeProvider', function ($route) {
    $route.when("/prices", {
      controller: 'priceListCtrl',
      templateUrl: "/prices/price-list.html"
    });
    $route.when("/promotions", {
      controller: 'promotionListCtrl',
      templateUrl: "/promotions/promotion-list.html"
    });
    $route.when("/revisions", {
      controller: 'revisionsCtrl',
      controllerAs: '$ctrl',
      templateUrl: "/revisions/index.html"
    });
    $route.when("/import", {
      controller: 'importCtrl',
      controllerAs: '$ctrl',
      templateUrl: "/import/index.html"
    });
    $route.when("/settings", {
      controller: 'settingsCtrl',
      controllerAs: '$ctrl',
      templateUrl: "/settings/settings.html"
    });
    $route.when("/error", {
      //controller: 'errorCtrl',
      templateUrl: "/views/error.html"
    });
    $route.otherwise({
      controller: 'introCtrl',
      templateUrl: "/intro/intro.html"
    });
  }]);

})();
